import { Component } from 'react';
import CollapsibleDefault from './CollapsibleDefault';
import { apiGetP, apiPrefix } from '../../GanjiTools';
import Theme from '../theme/Theme';
import { Tooltip } from 'devextreme-react';
import Badge from '../utils/Badge';

class ViewDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [{ url: '' }],
        }
    }

    static renderItem({ doc, table, tableRowId, width, height, index }) {
        return (
            <div style={{ padding: '10px', overflow: 'hidden', height: '100%' }}
                id={`aux_${table}_${tableRowId}_${doc.id ?? 0}_${index ?? 0}`}
                key={`aux_${table}_${tableRowId}_${doc.id ?? 0}_${index ?? 0}`}
            >
                <a href={apiPrefix + doc.url}
                    style={{ display: 'flex', borderRadius: '10px', backgroundColor: Theme.col0('lightgray'), padding: '10px' }}
                >
                    {doc.imageUrl?.length > 0
                        ?
                        <img src={apiPrefix + doc.imageUrl}
                            width={width ?? '200px'} height={height ?? '280px'}
                            style={{ objectFit: 'contain' }}
                            alt={doc.fileName + ' ' + (doc.comment ?? '')}
                        />
                        :
                        <div
                            style={{
                                width: width ?? '200px', height: height ?? '280px',
                                display: 'flex', alignItems: 'center',
                                color: 'blue', textWrap: 'auto'
                            }}
                        >
                            {doc.fileName}
                        </div>
                    }
                </a>
            </div>
        );
    }

    renderBody = () => (
        <div style={{
            width: '100%', height: '100%', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'flex-start',
            borderRadius: '10px', backgroundColor: 'transparent', //Theme.col1('gray')
        }}
        >
            {this.state.list?.filter(this.props.filter ?? (x => x.rowId > 0))
                .map((doc, ix) => ViewDocuments.renderItem({
                    doc,
                    table: this.props.table,
                    tableRowId: this.props.rowId,
                    width: this.props.itemWidth,
                    height: this.props.itemHeight,
                    index: ix
                }))}
        </div>
    );

    loadData = () => {
        if (!(this.props.rowId > 0) || !this.props.table)
            return;

        apiGetP(`/api/tarabar/auxFiles/${this.props.table}/${this.props.rowId}`)
            .then(res => {
                let { list, error } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ list });
                console.log(this.props.table, ' row#', this.props.rowId, ' docs:', list);
            });
    }

    componentDidUpdate(prevProps) {
        if (prevProps?.rowId !== this.props.rowId || prevProps?.table !== this.props.table) {
            console.log('ViewDocuments: detected prop change, reloading list for', this.props.table, this.props.rowId);
            this.setState({ list: [] }, this.loadData);
        }
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        const badge = this.state.list?.filter(this.props.filter ?? (x => x.rowId > 0))?.length ?? 0;
        return (
            <div style={{
                width: this.props.width, height: '100%'
            }}>
                {this.props.noCollapsible
                    ?
                    this.renderBody()
                    :
                    <CollapsibleDefault title='اسناد' width={this.props.width}
                        summary={badge > 0 && <Badge text={badge} size={24} style={{ opacity: '50%' }} />}
                    >
                        {this.renderBody()}
                    </CollapsibleDefault>
                }

                {this.state.list?.map((doc, ix) =>
                    <Tooltip target={`#aux_${this.props.table}_${this.props.rowId}_${doc?.id ?? 0}_${ix ?? 0}`}
                        key={ix}
                        rtlEnabled
                        showEvent='mouseenter' hideEvent='mouseleave'
                        hideOnOutsideClick={false}
                    >
                        دسته:
                        {doc.cat}
                        <br />
                        نام فایل:
                        {doc.fileName}
                        <br />
                        توضیح:
                        {doc.comment}
                    </Tooltip >
                )}
            </div>
        );
    }
}

export default ViewDocuments;
